import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";

const initialUtilityState = {
    showMenu: true,
    isLoading: true,
    dateError: null,
    themes: [
        {
            id: 1,
            name: "light",
            icon: "sun",
            selected: true,
        },
        {
            id: 2,
            name: "dark",
            icon: "moon",
            selected: false,
        }
    ]
};

export const changeTheme = createAsyncThunk('utility/changeTheme ', async (initialState) => {
    await localStorage.setItem('theme',initialState);
    return initialState;
});

export const fetchTheme = createAsyncThunk('utility/fetchTheme ', async () => {
    return localStorage.getItem('theme');
});


const utilitySlice = createSlice({
    name: "utility",
    initialState: initialUtilityState,
    reducers: {
        changeShowMenu(state) {
            state.showMenu = !state.showMenu
        },
        setLoading(state, action) {
            state.isLoading = action.payload;
        }
    },
    extraReducers(builder) {
        builder
            // Change theme
            .addCase(changeTheme.fulfilled, (state, action) => {
                state.themes.map(item => {
                    if (item.id === action.payload) return item.selected = true;
                    return item.selected = false;
                });
            })
            // fetch theme from local storage
            .addCase(fetchTheme.fulfilled, (state, action) => {
                state.themes.map(item => {
                    if (item.id === +action.payload) return item.selected = true;
                    return item.selected = false;
                });
            })
    }
});

export const getMenuStatus = state => state.utility.showMenu;
export const getThemes = state => state.utility.themes;
export const getActiveTheme = state => {
    const activeTheme = state.utility.themes.find(item => item.selected === true);
    return activeTheme ?  activeTheme : state.utility.themes[0];
};
export const {changeShowMenu,setLoading} = utilitySlice.actions;

export default utilitySlice.reducer;

